//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import "../../../desktop/webinar/WebinarCard/WebinarCard"
import Alodokter from "../../../../utils/Alodokter";
import "./WebinarLandingList.style";

import {
    _isShowNextBtn,
    _isShowPreviousBtn,
    _checkEmptyData,
    _getQueryParamPagination
} from "../../../../utils/Webinar";
import WebinarAnalytics from "../../../../analytics/WebinarAnalytics";

class WebinarLandingList extends PolymerElement {
    static get template() {
        return html `
            <style include="webinar-landing-list-style"></style>
                <div>
                    <h1>Cari Webinar Sesuai Minat Anda</h1>
                    <hr class="horizontal-border-grey">
                    <div class="webinar-list-container">
                        <template is="dom-if" if="[[_checkEmptyData(webinarList)]]">
                            <div class="content-empty">
                                <h2>Konten Tidak Ditemukan</h2>
                                <p>Silakan atur ulang filter yang Anda gunakan. </p>
                            </div>
                        </template>
                        <dom-repeat items="{{webinarList}}" as="webinarItem">
                            <template>
                                <webinar-card 
                                  webinar-item={{webinarItem}} 
                                  user-uid={{userUid}} 
                                  is-login={{isLogin}}
                                  on-tracking-impression-load="_handleTrackingLoad"
                                  on-tracking-impression-scroll="_handleTrackingScroll"
                                ><webinar-card>
                            </template>
                        <dom-repeat>
                    </div>
                    <div class="btn-group">
                        <template is="dom-if" if="[[!_isShowPreviousBtn(webinarList)]]">
                            <button id="_prevBtn" on-click="_prevBtn">< Sebelumnya</button>
                        </template>
                        <template is="dom-if" if="[[_isShowNextBtn(webinarList)]]">
                            <button id="_nextBtn" on-click="_nextBtn">Selanjutnya ></button>
                        </template>
                    </div>
                </div>
        `;
    }

    static get properties() {
        return {
            webinarList: {
                type: Array,
            },

            userUid: {
                type: String,
            },

            isLogin: {
                type: Number
            },

            localStorage: {
                type: String,
                value: localStorage.getItem("page"),
            },

            _isShowNextBtn: {
                type: Function,
                value: () => _isShowNextBtn,
            },

            _isShowPreviousBtn: {
                type: Function,
                value: () => _isShowPreviousBtn,
            },

            _checkEmptyData: {
                type: Function,
                value: () => _checkEmptyData,
            },
            _getQueryParamPagination: {
                type: Function,
                value: () => _getQueryParamPagination,
            },
            listImpressionsOnLoad: {
                type: Array,
                value: [],
            },
        }
    }
    
    ready() {
        super.ready();

        WebinarAnalytics.viewItemList(this.webinarList, false); // GA4

        window.addEventListener("load", function() {
            WebinarAnalytics.viewItemList(this.listImpressionsOnLoad, true);
        }.bind(this));
    }

    _nextBtn() {
        this.sendGAWebinarNextPaginationClicked();
        let page = 2
        var queryParams = new URLSearchParams(window.location.search);
        let currentPagination = queryParams.get('page');

        // ANOMALI CASE
        if (this.webinarList.length > 5 ) {
            if (queryParams == ''){ //Handling anomali case if it were on the first page
                const pageThree = 3
                localStorage.setItem("page", pageThree);
                return window.location = window.location.origin + '/webinar?page=' + pageThree
            } else if (this.webinarList.length > 10) {
                let pagination = parseInt(currentPagination) + 2
                localStorage.setItem("page", pagination);
                queryParams.set("page", pagination.toString());
                let newUrlParam = new URL(window.location.origin + "/webinar" + "?" + queryParams.toString());
                let incrementParams = newUrlParam 
                return window.location = incrementParams
            }
        }

        // NORMAL CASE
        if (queryParams == ''){ 
            window.location = window.location.origin + '/webinar?page=' + page
        } else if (this.webinarList.length >= 5 && this.webinarList.length <= 10){
            currentPagination ++
            queryParams.set("page", currentPagination);
            let newUrlParam = new URL(window.location.origin + "/webinar" + "?" + queryParams.toString());
            let incrementPage = newUrlParam 
            return window.location = incrementPage
        } 
    }

    _prevBtn() {
        this.sendGAWebinarPrevPaginationClicked();
        var queryParams = new URLSearchParams(window.location.search);
        let currentPage = queryParams.get('page');

        // ANOMALI CASE
        if (currentPage === this.localStorage) {
            localStorage.removeItem('page');
            let pagination = parseInt(currentPage) - 2 //decrementing query param value by 2
            queryParams.set("page", pagination.toString());
            let newUrlParam = new URL(window.location.origin + "/webinar" + "?" + queryParams.toString());
            let decrementPageParam = newUrlParam 
            return window.location = decrementPageParam
        } 

        // REGULAR CASE
        if (currentPage > 2) {
            currentPage -- 
            queryParams.set("page", currentPage);
            let newUrlParam = new URL(window.location.origin + "/webinar" + "?" + queryParams.toString());
            let decrementPageParam = newUrlParam
            return window.location = decrementPageParam

        } else if (currentPage <= 2 ){
            currentPage -- 
            queryParams.set("page", currentPage);
            let newUrlParam = new URL(window.location.origin + "/webinar" + "?" + queryParams.toString());
            let decrementPageParam = newUrlParam
            return window.location = decrementPageParam
        }
    }

    getTrackingUserUid() {
        return this.userUid && this.isLogin ? `user_uid: ${this.userUid} | ` : "";
    }

    sendGAWebinarNextPaginationClicked() {
        const webinarPagePosition = this._getQueryParamPagination();
        const userUid = this.getTrackingUserUid();
        const eventLabel = `${userUid} next_page: ${webinarPagePosition} | device_category: desktop`
        Alodokter.sendEventGA("webinar landing page", "webinar_next_pagination_clicked", eventLabel);
    }

    sendGAWebinarPrevPaginationClicked() {
        const webinarPagePosition = this._getQueryParamPagination();
        const userUid = this.getTrackingUserUid();
        const eventLabel = `${userUid}previous_page: ${webinarPagePosition} | device_category: desktop`
        Alodokter.sendEventGA("webinar landing page", "webinar_previous_pagination_clicked", eventLabel);
    }

    _handleTrackingLoad(e, data) {
        this.push("listImpressionsOnLoad", data);
    }

    _handleTrackingScroll(e, data) {
        WebinarAnalytics.viewItemList([data], true);
    }
}
customElements.define("webinar-landing-list", WebinarLandingList);